import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Typography } from "@mui/material";
import { signIn } from '@/legacy/redux';
import { LinkButton } from '@/components';

const SignIn = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      dispatch(signIn());
    }, 2000);
  }, []);

  return (
    <div className="m-auto flex flex-col items-center gap-4 rounded-2xl border border-border px-16 py-8">
      <Typography component="h1" variant="h1" align="center">
        Redirecting
      </Typography>
      <Typography component="h2" variant="body1" align="center">
        Redirecting to our login server. If you are not redirected in a few seconds, please return to the site and try again
      </Typography>
      <LinkButton to="/">
        Return to website
      </LinkButton>
    </div>
  );
}

export default SignIn;
